import Toasted from "vue-toasted";
import { notifications } from "../config";

export default {
  install(Vue) {
    const check = type => {
      if (typeof notifications === "boolean") return notifications;

      if (Array.isArray(notifications)) {
        return notifications.includes(type);
      }

      return false;
    };

    Vue.use(Toasted, { position: "top-right", duration: 5000 });

    Vue.prototype.$message = function(message) {
      if (check("info")) {
        this.$toasted.show(message, {
          type: "info"
        });
      }
    };

    Vue.prototype.$info = Vue.prototype.$message;

    Vue.prototype.$error = function(message) {
      if (check("error")) {
        this.$toasted.show(message, {
          type: "error"
        });
      }
    };

    Vue.prototype.$success = function(message) {
      if (check("success")) {
        this.$toasted.show(message, {
          type: "success"
        });
      }
    };
  }
};
